var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showError)?_c('div',[_c('weex-text',{staticClass:"font-size-sm-base text-color-red"},[_vm._v(_vm._s(_vm.errorMsg))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }